import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VModal from 'vue-js-modal'
import Swal from 'sweetalert2'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/styles/qhatu-admin-ux.css'

axios.defaults.baseURL = 'https://apibi.gruposolimano.com.pe/api/'
// axios.defaults.baseURL = 'https://localhost:7082/api/'

axios.defaults.timeout = 45000

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  const isQhatuApi = !/^https?:\/\//i.test(config.url || '') || (config.url || '').startsWith(axios.defaults.baseURL)
  if (token && isQhatuApi) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let showingExpiredSession = false
axios.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response && error.response.status
    const requestUrl = String(error.config && error.config.url || '')
    const isLoginRequest = requestUrl.includes('Autentication/LoginBI')
    const isQhatuApi = !/^https?:\/\//i.test(requestUrl) || requestUrl.startsWith(axios.defaults.baseURL)

    if (status === 401 && isQhatuApi && !isLoginRequest && !showingExpiredSession) {
      showingExpiredSession = true
      localStorage.removeItem('access_token')
      localStorage.removeItem('userId')
      localStorage.removeItem('idTrabajdor')
      localStorage.removeItem('idSolxPostulante')
      localStorage.removeItem('idPerfil')
      localStorage.removeItem('idContacto')

      await Swal.fire({
        title: 'Tu sesión venció',
        text: 'Por seguridad, vuelve a iniciar sesión para continuar.',
        icon: 'info',
        confirmButtonText: 'Ir al inicio de sesión',
        confirmButtonColor: '#0b5db7',
        allowOutsideClick: false,
      })
      showingExpiredSession = false
      if (router.currentRoute.path !== '/') router.replace('/').catch(() => { })
    }

    return Promise.reject(error)
  },
)

Vue.config.productionTip = false
Vue.use(Vueaxios, axios)
Vue.use(VModal)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
